import Backbone from 'backbone';
import invariant from 'invariant-slim';

const $ = Backbone.$;

let PartialOverpanelView = Backbone.View.extend({
	initialize ({ container, el, offsetTop = 0 }) {
		invariant(container, 'container not provided');
		invariant(el, 'el not provided');
		invariant(el.parentNode, 'element has no parent');
		invariant(el.innerHTML, 'el empty');
		this._offsetTop = offsetTop;
		this.$container = container instanceof $ ? container : $(container);
		invariant(
			this.$container.css('position') !== 'static',
			'cannot place a partial overpanel in a statically positioned container. consider position: relative'
		);
		this.replaceElementWithPlaceholder();
		this.render();
		this.show();
	},
	replaceElementWithPlaceholder() {
		let $placeholder = $('<div />', {
			css: {
				margin: 0,
				padding: 0,
				border: 'none',
				width: this.$el.outerWidth(),
				height: this.$el.outerHeight()
			}
		});
		this.$el.replaceWith($placeholder);
		this._putElementBack = () => $placeholder.replaceWith(this.$el);
	},
	render () {
		this.$overlay = this.createOverlay();
		this.$mask = this.createMask();
		this.$panel = this.createPanel();

		this.$overlay.css({
			visibility: 'hidden',
			top: this._offsetTop
		});

		this.$overlay.append(this.$mask);
		this.$overlay.append(this.$panel);
		this.$panel.append(this.$el);

		this.$container.append(this.$overlay);
		// now that it's there and laid out, it has height, so
		// we can position it for the slidedown
		this.$panel.css(
			'top', -(this.$panel.outerHeight())
		);
	},
	createOverlay () {
		return $('<div />', {
			'class': 'partialOverpanel',
			css: {
				position: 'absolute',
				left: 0,
				top: 0,
				right: 0,
				bottom: 0,
				overflow: 'hidden'
			}
		});
	},
	createMask () {
		return $('<div />', {
			'class': 'partialOverpanel-mask',
			css: {
				position: 'absolute',
				left: 0,
				top: 0,
				right: 0,
				bottom: 0,
				background: 'black'
			}
		});
	},
	createPanel () {
		return $('<div />', {
			'class': 'partialOverpanel-panel',
			css: {
				position: 'absolute',
				left: 0,
				right: 0
			}
		}).append(
			`<a class="close partialOverpanel-close">
				<span class="icon icon-close-small" aria-hidden="true">
				<span class="accessAid">Close</span>
			</a>`
		);
	},
	show () {
		this.$overlay.css('visibility', 'visible');
		this.$mask.addClass('is-visible');
		this.$panel.animate({ top: 0 });
		this.$panel.on('click', '.close', this.destroy.bind(this));
		this.$panel.promise().done(() => {
			this.trigger('show');
		});
	},
	hide () {
		this.$panel.animate({ top: -(this.$panel.outerHeight()) });
		this.$mask.removeClass('is-visible');
	},
	destroy () {
		this.hide();
		return this.$panel.promise().done(() => {
			this._putElementBack();
			this.$overlay.remove();
			this.trigger('destroy');
		});
	}
});

export default PartialOverpanelView;



// WEBPACK FOOTER //
// ./widgets/partialOverpanel.es6